import { nanoid } from 'nanoid';

const replaceUnsupportedSymbols = function (str) {
  return str.replace(/[^A-Za-z0-9]/g, '1');
};

const generateId = function () {
  return nanoid().replace(/[_-]/g, '1');
};

export {
  generateId,
  replaceUnsupportedSymbols,
};

export default nanoid;
